// getMessageHashtagContentList.js
'use strict';
import createCachedSelector from 're-reselect';

import { HASHTAG_REGEX_PATTERN } from '../RemoteConfigKeys.js';

import getMessageData from '../selector/getMessageData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';

/**
 * Select message hashtag content list by message id
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {string} messageId - message id.
 * @return {array|undefined} The selected message hashtag content list.
 */
const getMessageHashtagContentList = createCachedSelector(
  (state, messageId) => getMessageData(state, messageId, 'originalTitle'),
  (state, messageId) => getMessageData(state, messageId, 'originalCaptionText'),
  state => getRemoteConfigData(state, HASHTAG_REGEX_PATTERN),
  (originalTitle = '', originalCaptionText = '', hashtagRegexPattern) => {
    if ((!originalTitle && !originalCaptionText) || !hashtagRegexPattern) {
      return;
    }
    const hashtagRegex = new RegExp(hashtagRegexPattern, 'gm');
    return [
      ...`${originalTitle} ${originalCaptionText}`.matchAll(hashtagRegex),
    ].map(result => result.groups?.hashtag);
  }
)((state, messageId) => `${messageId}`);

export default getMessageHashtagContentList;
